import { useLocation } from 'react-router-dom';
import { PAGE_TITLES } from '@/constants/titles';

/**
 * Hook để lấy title của page hiện tại dựa trên route
 */
export function usePageTitle() {
  const location = useLocation();

  // Mapping từ pathname đến page title
  const getPageTitle = (pathname: string): string => {
    // Xử lý nested routes và exact matches
    if (pathname.startsWith('/share-cards')) return PAGE_TITLES.SHARE_CARDS;
    if (pathname.startsWith('/counterparts')) return PAGE_TITLES.COUNTERPART_MANAGEMENT;
    if (pathname.startsWith('/card')) {
      return PAGE_TITLES.CARD;
    }
    if (pathname.startsWith('/transaction')) {
      return PAGE_TITLES.TRANSACTION;
    }
    if (pathname.startsWith('/dashboard')) {
      return PAGE_TITLES.DASHBOARD;
    }
    if (pathname.startsWith('/ledger-accounts')) {
      return PAGE_TITLES.LEDGER_ACCOUNTS;
    }
    if (pathname.startsWith('/journals')) {
      return PAGE_TITLES.JOURNALS;
    }
    if (pathname.startsWith('/entries')) {
      return PAGE_TITLES.ENTRIES;
    }
    if (pathname.startsWith('/balance-containers')) {
      return PAGE_TITLES.BALANCE_CONTAINERS;
    }
    if (pathname.startsWith('/reconciliation')) {
      return PAGE_TITLES.RECONCILIATION;
    }
    if (pathname.startsWith('/seed-operations')) {
      return PAGE_TITLES.SEED_OPERATIONS;
    }
    if (pathname.startsWith('/users')) {
      return PAGE_TITLES.USERS;
    }
    if (pathname.startsWith('/settings')) {
      return PAGE_TITLES.SETTINGS;
    }
    if (pathname.startsWith('/login')) {
      return PAGE_TITLES.LOGIN;
    }
    if (pathname.startsWith('/not-found')) {
      return PAGE_TITLES.NOT_FOUND;
    }
    if (pathname.startsWith('/providers')) {
      return PAGE_TITLES.PROVIDER;
    }
    if (pathname.startsWith('/finance')) {
      return PAGE_TITLES.FINANCE;
    }
    if (pathname.startsWith('/account')) {
      return PAGE_TITLES.ACCOUNT;
    }
    if (pathname.startsWith('/event')) {
      return PAGE_TITLES.EVENT;
    }
    if (pathname.startsWith('/audit')) {
      return PAGE_TITLES.AUDIT;
    }
    if (pathname.startsWith('/customer')) {
      return PAGE_TITLES.CUSTOMER;
    }
    if (pathname.startsWith('/requests')) {
      return PAGE_TITLES.CustomerRequest;
    }
    if (pathname.startsWith('/stablecoin-management')) {
      return PAGE_TITLES.STABLECOIN_MANAGEMENT;
    }

    // Exact matches
    switch (pathname) {
      case '/':
        return PAGE_TITLES.ACCOUNT;
      case '/card':
        return PAGE_TITLES.CARD;
      case '/transaction':
        return PAGE_TITLES.TRANSACTION;
      case '/providers':
        return PAGE_TITLES.PROVIDER;
      case '/dashboard':
        return PAGE_TITLES.DASHBOARD;
      case '/ledger-accounts':
        return PAGE_TITLES.LEDGER_ACCOUNTS;
      case '/journals':
        return PAGE_TITLES.JOURNALS;
      case '/entries':
        return PAGE_TITLES.ENTRIES;
      case '/balance-containers':
        return PAGE_TITLES.BALANCE_CONTAINERS;
      case '/reconciliation':
        return PAGE_TITLES.RECONCILIATION;
      case '/seed-operations':
        return PAGE_TITLES.SEED_OPERATIONS;
      case '/user':
        return PAGE_TITLES.USERS;
      case '/account':
        return PAGE_TITLES.ACCOUNT;
      case '/audit':
        return PAGE_TITLES.AUDIT;
      case '/settings':
        return PAGE_TITLES.SETTINGS;
      case '/event':
        return PAGE_TITLES.EVENT;
      case '/customer':
        return PAGE_TITLES.CUSTOMER;
      case '/requests':
        return PAGE_TITLES.CustomerRequest;
      case '/stablecoin-management':
        return PAGE_TITLES.STABLECOIN_MANAGEMENT;
      case '/login':
        return PAGE_TITLES.LOGIN;
      case '/not-found':
        return PAGE_TITLES.NOT_FOUND;
      default:
        return '';
    }
  };

  return getPageTitle(location.pathname);
}
